module.exports = __webpack_public_path__ + "img/business_img0201.c8b41df3.jpg";